<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店名称">
                  <!-- <el-select v-model="queryForm.vendorId" filterable>
                    <el-option v-for="(item,idx) in vendorList" :key="idx" :label="item.label" :value="item.value"></el-option>
                  </el-select> -->
                  <BrandSelect :data="vendorList" v-model="queryForm.vendorId" filterable clearable></BrandSelect>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-table :data="tableData">
      <el-table-column prop="vendorName" label="买手店名称"></el-table-column>
      <el-table-column prop="countryName" label="国家"></el-table-column>
      <el-table-column prop="vendorTypeName" label="店铺类型"></el-table-column>
      <el-table-column prop="businessRegionName" label="业务区域"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link type="primary" @click="settingItem(scope.row)">设置</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import {
  getDiscountPromotionVendorList,
} from "../api.js";
import BrandSelect from '@/views/components/brandSelect.vue';

export default {
  data() {
    return {
      fullscreenLoading: false,
      vendorList: [],
      queryForm: {
        vendorId: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
    };
  },
  components: {BrandSelect},
  created() {
    getDiscountPromotionVendorList({
      pageNo: 1,
      pageSize: 1000,
    }).then(res => {
      if (res.data && res.data.list) {
        this.vendorList = res.data.list.map(item => {
          return {
            label: item.vendorName,
            value: item.vendorId,
          }
        })
      }
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorId = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getDiscountPromotionVendorList(this.queryForm).then(res => {
        if (res.data) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    settingItem(data) {
      const { vendorId, vendorName, coFlag, subVendorIs } = data
      let routeData = this.$router.resolve({
        path: `/discount/promotion/list/${vendorId}`,
        query: {
          name: vendorName,
          coFlag,
          subVendorIs,
        }
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
</style>
